import React from 'react';
import { Collapse } from 'antd';
import { TeamOutlined, DesktopOutlined, PlayCircleOutlined, RocketOutlined, ExperimentOutlined, EyeOutlined, ThunderboltOutlined } from '@ant-design/icons';

const { Panel } = Collapse;

function WorkSteps() {
  const steps = [
    {
      key: '1',
      title: 'Discovery & Strategy',
      subtitle: 'Understanding your vision',
      content: 'We dive deep into your business goals, target audience, and competitive landscape. Our project managers conduct comprehensive consultations to understand your unique brand story and create a tailored strategy that aligns with your objectives.',
      icon: <TeamOutlined />,
      duration: '1-2 weeks'
    },
    {
      key: '2', 
      title: 'Strategic Planning',
      subtitle: 'Architecting your success',
      content: 'Our team creates detailed sitemaps, user journey maps, and technical specifications. We match you with specialized designers who understand your industry and aesthetic preferences, ensuring the perfect fit for your project.',
      icon: <DesktopOutlined />,
      duration: '1 week'
    },
    {
      key: '3',
      title: 'Homepage Design',
      subtitle: 'Creating your digital front door', 
      content: 'Multiple homepage concepts are crafted with conversion optimization in mind. We present the top designs for your review and conduct user testing to ensure maximum engagement and effectiveness.',
      icon: <PlayCircleOutlined />,
      duration: '2-3 weeks'
    },
    {
      key: '4',
      title: 'Page Development',
      subtitle: 'Expanding your digital presence',
      content: 'Complete page layouts are designed for all sections of your website, including blog templates, contact forms, and service pages. Every element is optimized for user experience and conversion.',
      icon: <DesktopOutlined />,
      duration: '2-3 weeks'
    },
    {
      key: '5',
      title: 'Development & SEO',
      subtitle: 'Building with performance in mind',
      content: 'Our developers transform designs into high-performance websites with clean code, fast loading times, and search engine optimization built-in from the ground up.',
      icon: <RocketOutlined />,
      duration: '3-4 weeks'
    },
    {
      key: '6',
      title: 'Quality Assurance',
      subtitle: 'Ensuring perfection',
      content: 'Comprehensive testing across all devices, browsers, and platforms. We verify functionality, performance, and user experience to guarantee your website exceeds expectations.',
      icon: <ExperimentOutlined />,
      duration: '1 week'
    },
    {
      key: '7',
      title: 'Final Review',
      subtitle: 'Your approval matters',
      content: 'We present the completed website for your final review. Any adjustments or refinements are implemented to ensure the final product perfectly matches your vision.',
      icon: <EyeOutlined />,
      duration: '1 week'
    },
    {
      key: '8',
      title: 'Launch & Beyond',
      subtitle: 'Going live with confidence',
      content: 'Your website goes live with comprehensive monitoring and support. We provide training, documentation, and ongoing maintenance to ensure continued success.',
      icon: <ThunderboltOutlined />,
      duration: '1 week'
    }
  ];

  return (
    <div id='works' className='block worksBlock bgGray'>
      <div className='container-fluid'>
        <div className='titleHolder'>
          <h2>Our Proven Process</h2>
          <p>A streamlined approach to delivering exceptional web experiences. Each step is carefully designed to ensure your project's success.</p>
        </div>
        
        <Collapse defaultActiveKey={['1']} className='process-collapse'>
          {steps.map((step, index) => (
            <Panel 
              key={step.key}
              header={
                <div className='process-header'>
                  <div className='step-icon'>{step.icon}</div>
                  <div className='step-info'>
                    <h4 className='step-title'>{step.title}</h4>
                    <span className='step-subtitle'>{step.subtitle}</span>
                    <span className='step-duration'>Duration: {step.duration}</span>
                  </div>
                  <div className='step-number'>{String(index + 1).padStart(2, '0')}</div>
                </div>
              }
            >
              <div className='process-content'>
                <p>{step.content}</p>
              </div>
            </Panel>
          ))}
        </Collapse>

        <div className='quickSupport'>
          <h3>Ready to get started?</h3>
          <p>Let's discuss your project and create something amazing together!</p>
          <a className='ant-btn ant-btn-primary' href='#contact'>
                      <i href='#contact' className='fas fa-desktop'></i> Get in
                      Touch
                    </a>
        </div>
      </div>
    </div>
  );
}

export default WorkSteps;